import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-section-loader',
  templateUrl: './shared-section-loader.component.html',
  styleUrls: ['./shared-section-loader.component.scss'],
})
export class SharedSectionLoaderComponent {}
